import React from "react";
import { withRouter } from "react-router-dom";
import { Box } from "./style";
import { Confirm } from "../../../../components/confirm";
import { isEqual } from "lodash";
import { toastr } from "react-redux-toastr";
import { WARNING_SINGLE_BUTTON_TEXT } from "../../../../constants/otherTexts";
import Modal from "../../../../components/imageSlider/modal";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalStatus: false,
      currentShow: 0,
      filesBoxWidth: 0
    };
    this.FilesBox = React.createRef();
  }

  componentDidMount() {
    this.setState({
      filesBoxWidth: this.FilesBox.current.getBoundingClientRect().width
    });
  }

  componentDidUpdate() {
    const {
      history: {
        location: { state }
      },
      input: { value: files }
    } = this.props;
    if ((!files || !files.length) && this.state.modalStatus) {
      this.closeModalOrConfirm("modalStatus");
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      input: { value: files }
    } = this.props;
    const {
      input: { value: nextFiles }
    } = nextProps;
    return !isEqual(nextState, this.state) || !isEqual(nextFiles, files);
  }

  checkTypeCorrectnessOfImages(files) {
    let correctType = true;
    for (let i = 0; i < files.length; i++) {
      if (this.props.accept.indexOf(files[i]["type"]) < 0) {
        correctType = false;
      }
    }
    return correctType;
  }

  inputView(i) {
    let {
      limitConstants,
      input: { value: files },
      accept,
      checkLimitation,
      change,
      limit
    } = this.props;
    const remainImgs =
      limitConstants && limitConstants.transaction_image_count_limit;
    const maxNumOfSelectableImgs = remainImgs
      ? Math.min(limit - files.length, remainImgs)
      : limit;
    return (
      <React.Fragment>
        <Confirm
          show={this.state.modalShow}
          content={{
            type: "danger",
            icon: "icon mapsa-notification",
            message: this.state.modalMessage,
            rejectButtonText: WARNING_SINGLE_BUTTON_TEXT
          }}
          rejectHandler={() => this.closeModalOrConfirm("modalShow")}
          close={() => this.closeModalOrConfirm("modalShow")}
        />
        <input
          type="file"
          name="file"
          id={"file" + i}
          multiple
          className="input-file"
          onClick={e => {
            e.target.value = "";
            if (checkLimitation && checkLimitation(false, files.length)) {
              e.preventDefault();
              checkLimitation(true, files.length);
            }
          }}
          onChange={e => {
            if (e.target.files.length > maxNumOfSelectableImgs) {
              toastr.error(
                "",
                `حداکثر ${maxNumOfSelectableImgs} تصویر را می‌توانید انتخاب کنید.`
              );
              change(
                "files",
                files.concat(
                  [...e.target.files].slice(0, maxNumOfSelectableImgs)
                )
              );
            } else if (this.checkTypeCorrectnessOfImages(e.target.files)) {
              change("files", files.concat(...e.target.files));
            } else {
              this.showModalOrConfirm(
                "modalShow",
                "modalMessage",
                "فرمت فایل ارسالی مجاز نمی‌باشد و تنها بارگذاری فایل‌های JPEG, JPG و PNG مجاز است."
              );
              return false;
            }
            return false;
          }}
          accept={accept && accept.join(",")}
        />
      </React.Fragment>
    );
  }

  closeModalOrConfirm(stateName) {
    const { history } = this.props;
    this.setState({ [stateName]: false });
    history.goBack();
  }

  showModalOrConfirm(stateName, extraKey, extraValue) {
    this.setState({
      [stateName]: true,
      [extraKey]: extraValue
    });
  }

  bigAdd(i) {
    const {
      input: { value: files },
      isFixed
    } = this.props;
    if (files) {
      return (
        <React.Fragment key={i}>
          {this.inputView(i)}
          {files.length === 0 && !isFixed ? (
            <label htmlFor={"file" + i} className={`add-file`}>
              افزودن پیوست
            </label>
          ) : (
            <div className="add-file-big">
              <label htmlFor={"file" + i}>
                <i className="icon mapsa-plus" />
              </label>
            </div>
          )}
        </React.Fragment>
      );
    }
  }

  remove(index) {
    const {
      input: { value: files }
    } = this.props;
    let deleted_images = this.props.deleted_images;
    let result = [];
    if (files) {
      files.forEach((item, i) => {
        if (i !== index) {
          result.push(item);
        }
      });
    }
    if (files[index] && files[index]["id"]) {
      deleted_images.push(files[index]["id"]);
      this.props.change("deleted_images", deleted_images);
    }
    this.props.change("files", result);
    let newCurrent = index - 1;
    if (newCurrent === -1) {
      newCurrent = result.length - 1;
    }
    this.setState({
      currentShow: newCurrent
    });
  }

  src(file) {
    if (file.id) {
      return file.path;
    } else {
      return window.URL.createObjectURL(file);
    }
  }

  toggleRefreshButton(index, show) {
    const id = `#refreshButtonId-${index}`;
    const refreshButton = document.querySelector(`${id}`);
    if (show) {
      refreshButton.style.display = "flex";
    } else {
      refreshButton.style.display = "none";
    }
  }

  reloadImage(e, index, imageSrc) {
    const id = `#imageId-${index}`;
    e.stopPropagation();
    const img = document.querySelector(`${id}`);
    img.src = imageSrc;
    this.toggleRefreshButton(index, false);
  }

  showModal(selectedImage) {
    this.setState({ modalStatus: true });
    this.setState({
      currentShow: selectedImage
    });
  }

  imagesView(files, emptyArray) {
    const { unDeletable, show } = this.props;
    return (
      <React.Fragment>
        {files &&
          files.length > 0 &&
          files.map((file, i) => (
            <div className="file" key={i}>
              <img
                id={`imageId-${i}`}
                src={this.src(file)}
                alt={`imageId-${i}`}
                onClick={e => {
                  e.stopPropagation();
                  this.showModal(i);
                }}
                onError={() => {
                  this.toggleRefreshButton(i, true);
                }}
                onLoad={() => this.toggleRefreshButton(i, false)}
              />
              {!unDeletable && (
                <i
                  className="icon mapsa-delete"
                  onClick={e => {
                    e.stopPropagation();
                    this.remove(i);
                  }}
                />
              )}
              <div
                className="refresh-button-container"
                id={`refreshButtonId-${i}`}
                onClick={e => this.reloadImage(e, i, file.path)}
              >
                <img src="/images/refresh.png" alt="" />
              </div>
            </div>
          ))}
        {!show && emptyArray.map((item, i) => this.bigAdd(i))}
      </React.Fragment>
    );
  }

  renderPics() {
    const {
      input: { value: files },
      limit,
      isFixed
    } = this.props;
    if (!files || (files.length <= limit && limit >= 0)) {
      const size = files ? limit - files.length : limit;
      const array = isFixed ? Array(parseInt(size)).fill(null) : [null];
      return this.imagesView(files, array);
    }
  }

  closeModal() {
    this.setState({ modalStatus: false });
  }

  modalView() {
    const { modalStatus, currentShow } = this.state;
    const {
      input: { value: files }
    } = this.props;
    return (
      <Modal
        show={modalStatus}
        files={files}
        current={currentShow}
        close={() => this.closeModal()}
      />
    );
  }

  render() {
    const { filesBoxWidth } = this.state;
    const { limit, isFixed, show } = this.props;
    return (
      <Box
        viewWidth={filesBoxWidth}
        ref={this.FilesBox}
        imagesNum={Math.min(
          show || isFixed ? parseInt(limit) : parseInt(limit) + 1,
          4
        )}
      >
        <div className="files">{this.renderPics()}</div>
        {this.modalView()}
      </Box>
    );
  }
}

export default withRouter(Index);
